import { HIDDEN_MODULES } from '@/config/config';

export const showModule = (moduleName: string): boolean => {
  return !HIDDEN_MODULES.includes(moduleName);
};
